import apiFetch from 'utils/apiFetch';

export const getEmbeddable = (id) => {
  return apiFetch('GET', { endPoint: `embeddables/${id}` });
};



// WEBPACK FOOTER //
// ./src/modules/embeddables/actions.js